import apiClient from "./apiClient";
import { Order, OrderItem, StockAvailabilityRequest } from "../types";
import { checkStockAvailability } from "./stockService";

// Используем Order из types

interface OrderResponse {
  message: string;
  order: Order;
}

interface StockAvailabilityResponse {
  warehouse_id: number;
  result: {
    available: boolean;
    unavailable_items: Array<{
      product_id: number;
      requested_qty: number;
      available_qty: number;
      is_out_of_stock: boolean;
    }>;
    total_available_amount: number;
  };
}

export const fetchOrders = async (): Promise<Order[]> => {
  try {
    const response = await apiClient.get<{ orders: Order[] }>("/api/orders");
    return response.data.orders || [];
  } catch (error) {
    console.error("Не удалось загрузить заказы:", error);
    throw error;
  }
};

export const postOrders = async (orderData: Partial<Order>): Promise<OrderResponse> => {
  try {
    // Создаем заказ - проверка доступности уже была выполнена на фронтенде
    // Бэкенд также выполнит финальную проверку перед созданием заказа
    const response = await apiClient.post<OrderResponse>("/api/orders", orderData);
    return response.data;
  } catch (error) {
    console.error("Ошибка создания заказа:", error);
    throw error;
  }
};

// Функция для проверки доступности товаров перед созданием заказа
export const validateOrderItems = async (
  warehouseId: number,
  items: OrderItem[]
): Promise<StockAvailabilityResponse> => {
  try {
    const availabilityItems: StockAvailabilityRequest[] = items.map(item => ({
      product_id: item.product_id,
      quantity: item.quantity,
      price: item.price
    }));

    return await checkStockAvailability(warehouseId, availabilityItems);
  } catch (error) {
    console.error("Ошибка валидации товаров заказа:", error);
    throw error;
  }
};
